<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a @click="backFX()" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>斐燃合伙人</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>

    <div class="fxa">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" loading-text="加载中" @load="onLoad" >
        <div v-for="(item,index) in list" :key="index" @click="todetail(item)" class="fxa_item">
          <div class="fxa_item_title">{{item.cards_name}} ¥{{item.total_fee}}</div>
          <div class="fxa_item_date">{{item.create_time}}</div>
          <div class="fxa_item_pos">
            <div v-show="item.status==2" class="fxa_item_pos_btn">
              未使用 &nbsp;
            </div>
            <div v-show="item.status==1" class="fxa_item_pos_btnunless">
              已使用 &nbsp;
            </div>
          </div>
        </div>
      </van-list>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        page:1,
        list:[],
        loading:true,
        finished:false,
      }
    },
    created() { },
    mounted() {
      this.getlist()
    },
    methods:{
      getlist(){
        var $this=this
        this.loading=true
        let param = {
          token: localStorage.getItem("token"),
          page:this.page
        }
        var qs = require('qs');
        let url = this.api.userApi.getCdkOrders
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          console.log($this.page)
          if(result.data==null){
            $this.finished=true
          }else{
            if($this.list.length==0){
              $this.list=result.data
            }else{
              $this.list=$this.list.concat(result.data)
            }
          }
          $this.loading=false
        }).catch((error) => {
          console.log(error)
        })
      },
      // 查看激活码详情
      todetail(item){
        console.log(item)
        var params={
          order_no:item.order_no
        }
        this.$router.push({
          name:'activedetail',
          params:params
        })
      },
      // 加载更多
      onLoad(){
        console.log('加载数据')
        var $this=this
        this.loading=true

        setTimeout(function(){
          $this.loading=false
          $this.page++
          $this.getlist()
        },1000)
      },
      // 返回分销
      backFX(){
        // console.log('返回分销')
        var url=encodeURI(window.location.href)
        if(url.indexOf('test')==-1){
          window.location.href='https://agency.unionfit.cn'
        }else{
          window.location.href='https://test.agency.unionfit.cn'
        }
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .fxa{
    width: 100%;
    padding: 50*@vm_base 24*@vm_base 0 24*@vm_base;
    .fxa_item{
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 4*@vm_base 20*@vm_base 0px #EEEEEE;
      border-radius: 12*@vm_base;
      padding: 50*@vm_base 30*@vm_base 40*@vm_base 30*@vm_base;
      margin-bottom: 30*@vm_base;
      position: relative;
      .fxa_item_title{
        width: 100%;
        font-size: 32*@vm_base;
        font-weight: bold;
        color: #333333;
        line-height: 32*@vm_base;
      }
      .fxa_item_date{
        width: 100%;
        font-size: 22*@vm_base;
        font-weight: 400;
        color: #7C7987;
        line-height: 30*@vm_base;
        margin-top: 16*@vm_base;
      }
      .fxa_item_pos{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .fxa_item_pos_btn{
          // height: 67*@vm_base;
          background: #F4D58F;
          border-radius: 34*@vm_base;
          // line-height: 67*@vm_base;
          font-size: 32*@vm_base;
          font-weight: 400;
          color: #444054;
          text-align: center;
          padding: 11*@vm_base 39*@vm_base;
          margin-right: 32*@vm_base;
          background-image: url('../../../assets/images/fenxiao/triangle_icon.png');
          background-position:83% 50%;
          background-repeat: no-repeat;
          background-size: 14*@vm_base auto;
        }
        .fxa_item_pos_btnunless{
          // height: 67*@vm_base;
          background: none;
          border: 1*@vm_base solid #979797;
          border-radius: 34*@vm_base;
          // line-height: 65*@vm_base;
          font-size: 32*@vm_base;
          font-weight: 400;
          color: #444054;
          text-align: center;
          padding: 11*@vm_base 39*@vm_base;
          margin-right: 32*@vm_base;
          background-image: url('../../../assets/images/fenxiao/triangle_icon.png');
          background-position:83% 50%;
          background-repeat: no-repeat;
          background-size: 14*@vm_base auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/unpublic/fxbuycode/activelist.vue